<template>
  <div class="mobile-approval">
    <div class="nav-bar">
      <span>邀请信息</span>
      <el-button type="text" class="flow-button" @click="vis=true">流程</el-button>
    </div>
    <div class="info-container">
      <h5 class="invitation-title">{{info.applyName}}</h5>
      <p class="invitation-info">{{info.informComment}}</p>
      <el-collapse>
        <el-collapse-item title="邀请函信息">
          <div class="info-row">
            办理签证(注)驻外使馆、领馆：
            <span>{{info.stayCountry}}{{info.stayTypeName}}</span>
          </div>
          <div class="info-row">
            签发人：
            <span>{{info.inviIssuer}}</span>
          </div>
          <div class="info-row">
            团长姓名：
            <span>{{info.applyLeaderName}} {{info.applyLeaderSurname}}</span>
          </div>
          <div class="info-row">
            签证(注)有效期：
            <span>{{info.certEffectMonth}}个月</span>
          </div>
          <div class="info-row">
            申请事由：
            <span>{{info.applyReasonName}}</span>
          </div>
          <div class="info-row">
            来访目的：
            <span>{{info.visitPurposeName}}</span>
          </div>
          <div class="info-row">
            访问地点：
            <span>{{info.visitLocation}}</span>
          </div>
          <div class="info-row">
            邀请人数：
            <span>{{info.inviNum}}</span>
          </div>
          <div class="info-row">
            拟入境日期：
            <span>{{info.preEntryDate}}</span>
          </div>
          <div class="info-row">
            拟出境日期：
            <span>{{info.preDepaDate}}</span>
          </div>
          <div class="info-row">
            最长停留天数：
            <span>{{info.maxStayDay}}</span>
          </div>
          <div class="info-row">
            拟入境次数：
            <span>{{info.preEntryNum}}</span>
          </div>
          <div class="info-row">
            是否是新项目：
            <span>{{info.newProFlag?"是":"不是"}}</span>
          </div>
          <div class="info-row">
            是否首次来华：
            <span>{{info.firstVisitFlag?"是":"不是"}}</span>
          </div>
          <div class="info-row">
            外国公司：
            <span>{{info.outsideCompanyName}}</span>
          </div>
          <div class="info-row">
            (机构)名称：
            <span>{{info.companyName}}</span>
          </div>
          <div class="info-row">
            外方传真号：
            <span>{{info.outsideFax}}</span>
          </div>
        </el-collapse-item>
        <el-collapse-item title="人员列表">
          <ul class="person-list">
            <li>
              <div class="name-container">
                <span>姓名</span>
              </div>
              <div class="sex-container">
                <span>性别</span>
              </div>
              <div class="country-container">
                <span>国籍</span>
              </div>
            </li>
            <li v-for="item in personList" :key="item.inviPerId">
              <div class="name-container">
                <span>{{item.perName}}</span>
              </div>
              <div class="sex-container">
                <span>{{item.perSex}}</span>
              </div>
              <div class="country-container">
                <span>{{item.perCountry}}</span>
              </div>
            </li>
          </ul>
        </el-collapse-item>
      </el-collapse>
    </div>
    <div class="approval-row" v-show="type!==3">
      <h5 v-if="showApproval" class="approval-content">审批</h5>
      <el-row v-if="showApproval" class="input-row">
        <el-input v-model="content"></el-input>
      </el-row>
      <el-row class="button-row" type="flex" justify="space-around">
        <el-button v-if="showApproval" class="pink-button" @click="submitApproval('N')">不同意</el-button>
        <el-button v-if="showOver" type="warning" @click="vis_other=true">请其他领导审批</el-button>
        <el-button v-if="showApproval" type="primary" @click="submitApproval('Y')">同&nbsp;&nbsp;意</el-button>
        <el-button v-if="showOver" type="primary" @click="submitApproval('Y',true)">结&nbsp;&nbsp;束</el-button>
      </el-row>
    </div>
    <el-dialog
      :visible.sync="vis"
      title="审批信息"
      width="325px"
      top="123px"
      :show-close="false"
      class="approval-dialog"
    >
      <div class="node-container">
        <div class="node-ele end" v-if="Number(info.applyStatus) >= 6">
          <div class="time-node">
            <span>{{endTime}}</span>
            <br>
            <span>{{endDate}}</span>
          </div>
          <div class="avatar-node">
            <p>结</p>
            <div class="grey-bar"></div>
          </div>
          <div class="content-node">流程结束</div>
        </div>
        <div
          :class="(Number(info.applyStatus)>=6 || num!==0)?'node-ele':'node-ele end'"
          v-for="(item,num) in flow"
          :key="item[0].approvalId"
        >
          <div class="time-node">
            <span v-show="item.length > 0">{{item[0].createTime.split(" ")[1]}}</span>
            <br>
            <span v-show="item.length > 0">{{item[0].createTime.split(" ")[0]}}</span>
          </div>
          <div class="avatar-node">
            <div class="grey-bar" v-show="num!==0 || Number(info.applyStatus) >= 6"></div>
            <p>{{item[0].userName.charAt(0)}}</p>
            <div class="grey-bar"></div>
          </div>
          <div class="content-node">
            <el-row>
              <span
                class="username"
                v-for="(unit,index) in item"
                :key="unit.approvalId+'_inner_'+index"
              >{{unit.userName}}</span>
            </el-row>
            <el-row v-show="item[0].agree == 'Y' && item[0].comment!=''">
              {{item[0].comment}}
            </el-row>
            <el-row v-show="item[0].agree == 'Y' && item[0].comment==''">
              同意
            </el-row>
            <el-row v-show="item[0].agree == 'N' && item[0].comment!=''">
              {{item[0].comment}}
            </el-row>
            <el-row v-show="item[0].agree == 'N' && item[0].comment==''">
              不同意
            </el-row>
          </div>
        </div>
        <div class="node-ele start">
          <div class="time-node">
            <span>{{info.createTime.split(" ")[1]}}</span>
            <br>
            <span>{{info.createTime.split(" ")[0]}}</span>
          </div>
          <div class="avatar-node">
            <div class="grey-bar"></div>
            <p>始</p>
          </div>
          <div class="content-node">
            <el-row>流程开始</el-row>
            <el-row>
              由
              <span style="font-size: 14px; font-weight: 700">{{startName}}</span> 发起
            </el-row>
          </div>
        </div>
      </div>
      <div class="close-icon" @click="vis=false">
        <i class="el-icon-close"></i>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="vis_other"
      title="请其他领导审批"
      width="325px"
      top="10vh"
      :show-close="false"
      class="approval-dialog"
    >
      <el-checkbox-group v-model="selected">
        <el-checkbox
          v-for="item in otherList"
          :key="item.accountUuid"
          :label="item.accountId"
        >{{item.userName}}({{item.deptName}})</el-checkbox>
      </el-checkbox-group>
      <div class="close-icon" @click="vis_other=false">
        <i class="el-icon-close"></i>
      </div>
      <el-row type="flex" justify="space-around">
        <el-button type="primary" @click="otherSubmit" v-loading="isLoad">确定</el-button>
        <el-button type="danger" @click="vis_other=false">取消</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import CorporationApi from "../../api/setup/index.js";
import InvitationApi from "../../api/foreign/foreign_Invitation_manage/InvitationAcceptApi.js";
import ApprovalApi from "../../api/foreign/foreign_Invitation_manage/InvitationApprovalApi.js";
export default {
  name: "mobile-approval",
  data() {
    return {
      info: {},
      content: "",
      flow: [],
      endList:[],
      personList: [],
      otherList: [],
      approvalId: null,
      vis: true,
      vis_other: false,
      showOver: false, //是否可以结束操作
      showApproval: true, //是否可以审批操作
      selected: [],
      isLoad: false,
      type: 3,
      startName: "",
      collapse1: false,
      collapse2: false,
      isShowFlow:false,
      firstFlowCreateTime:'',
      secondFlowCreateTime:'',
      processId: "",
      endTime:'',
      endDate:'',
    };
  },
  watch:{
    endList:{
      //获取流程结束时间 
      handler(newV){
         let timeList = newV;
        if(newV instanceof Array && newV.length){
          this.endTime = timeList[0][0].createTime.substr(11);
          this.endDate = timeList[0][0].createTime.substr(0,11);
        }
      },
      immediate:true
    }
  },
  methods: {

    otherSubmit() {
      let data = {
        approvalId: this.approvalId,
        users: this.selected.map(a => {
          let target = this.otherList.find(b => b.accountId === a);
          return { userName: target.userName, accountId: target.accountId };
        })
      };
      let http = new ApprovalApi();
      this.isLoad = true;
      http
        .handOtherApproval(data)
        .then(res => {
          this.isLoad = false;
          this.$message(res.msg);
          window.history.go(-1);
        })
        .catch(e => {
          this.isLoad = false;
        });
    },
    submitApproval(type, bool) {
      let text =
        "确认" + (type === "Y" ? "通过" : "否决") + "该邀请函，是否继续?";
      if (bool) {
        text = "确认结束审批流程吗?";
      }
      this.$confirm(text, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "mobile-messagebox",
        center: true
      })
        .then(() => {
          const loading = this.$loading({
            lock: true,
            text: "正在提交，请耐心等待.....",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          let http = new ApprovalApi();
          http
            .approvalInvitation({
              approvalId: this.approvalId,
              agree: type,
              comment: this.comment
            })
            .then(res => {
              this.$message.success("提交成功!");
              loading.close();
              this.$router.push({ path: "/mobile-approval-list" });
            })
            .catch(e => {
              console.log(e);
              loading.close();
            });
        })
        .catch(e => {
          console.log(e);
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  },
  mounted() {
    let http = new ApprovalApi();
    let typeBydb=new URLSearchParams(window.location.search).get('type')||''
    let idBydb=new URLSearchParams(window.location.search).get('id')||''
    this.type = this.$route.query.type?Number(this.$route.query.type):Number(typeBydb)
    
    // 获取基本信息
    http.getOneInviAppLy({ inviApplyId: this.$route.query.id||idBydb }).then(res => {
      this.info = res.data.apply;
      this.personList = res.data.personList;
      //如果当前登陆人是发起人 显示结束按钮
      if (
        res.data.apply.startFlowUser == this.$store.state.user.account.accountId
      ) {
        this.showOver = true;
        this.showApproval = false;
      }
    });
    // 获取流程,查找审批id
    http.getApprovalInfos({ inviApplyId: this.$route.query.id||idBydb }).then(res => {
      this.startName = res.data.start.userName;
      for (let i in res.data.logs) {
        this.flow.push(res.data.logs[i]);
        this.endList.push(res.data.logs[i])
        for (let m of res.data.logs[i]) {
          if (m.accountId === this.$store.state.user.account.accountId) {
            this.approvalId = m.approvalId;
            break;
          }
        }
        // if (this.approvalId) break;
      }
      this.flow.reverse();
      this.endList.reverse();
      this.flow = this.flow.filter(a => a[0].virNode !== "Y");
    });
    // 查询其他领导
    http.getLeaderList({}).then(res => {
      this.otherList = res.data;
    });
  }
};
</script>
<style lang="scss" scoped>
@function vw($p) {
  @return $p/750 * 100 + vw;
}
$light-blue: #0270c1;
.mobile-approval {
  .nav-bar {
    position: relative;
    height: vw(93);
    line-height: vw(93);
    text-align: center;
    border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
    font-size: 20px;
    .flow-button {
      position: absolute;
      right: vw(30);
      top: 50%;
      transform: translateY(-50%);
      padding: 0;
      color: #222;
      font-size: 17px;
    }
  }
  .info-container {
    padding: 0 vw(31);
    color: #222;
    .invitation-info {
      margin: 0;
      font-size: 15px;
      line-height: 1.2;
    }
    .invitation-title {
      font-size: 15px;
      color: $light-blue;
      line-height: 42px;
      margin-bottom: 5px;
    }
    .info-row {
      line-height: 20px;
      font-size: 15px;
      span {
        font-weight: bold;
      }
    }
  }
  .person-list {
    background-color: #f1f1f1;
    margin: 0;
    li {
      display: flex;
      padding: 5px 0;
      border-bottom: 1px solid #e5e5e5;
      text-align: center;

      .name-container {
        flex: 3;
      }
      .sex-container {
        flex: 1;
      }
      .country-container {
        flex: 1;
      }
    }
  }
  .approval-row {
    padding: vw(40) vw(31);
    .approval-content {
      font-size: 15px;
      margin: 0;
      margin-bottom: vw(20);
    }
    .input-row {
      border-radius: 15px;
      overflow: hidden;
      margin-bottom: vw(108);
      border: 1px solid #999;
      /deep/ .el-input {
        border: none;
        .el-input__inner {
          background-color: #fff;
        }
      }
    }
    .pink-button {
      width: 85px;
      height: 45px;
      padding: 0;
      line-height: 45px;
      background-color: #ffdbd9;
      color: #ff4d3f;
      border-radius: 22.5px;
    }
    /deep/ .el-button {
      border-radius: 22.5px;
    }
    /deep/ .el-button--primary {
      box-shadow: 0px 3px 5px 0px rgba(57, 144, 215, 0.5);
    }
  }
}
.approval-dialog {
  /deep/ .el-dialog {
    background: none;
  }
  /deep/ .el-dialog__header,
  /deep/ .el-dialog__body {
    background: white;
  }
  /deep/ .el-dialog__header {
    border-radius: 12px 12px 0 0;
    text-indent: 0;
    text-align: center;
  }
  /deep/ .el-dialog__body {
    border-radius: 0 0 12px 12px;
  }
  /deep/ .el-dialog__title {
    font-size: 20px;
  }
  .node-container {
    padding-left: 50px;
  }
  .node-ele {
    display: flex;
    align-items: center;
    .time-node {
      height: 30px;
      line-height: 15px;
      padding-right: 8px;
      color: #999;
      text-align: center;
      span:first-child {
        font-size: 13px;
      }
      span:last-child {
        font-size: 12px;
      }
    }
    .content-node {
      max-width: 120px;
      min-height: 24px;
      padding-left: 10px;
      color: #999;
      font-size: 13px;
      line-height: 1.2;
      .username + .username {
        margin-left: 1em;
      }
    }
    .avatar-node {
      height: auto;
      .grey-bar {
        height: 25px;
        width: 1px;
        margin: 2px auto;
        background-color: #e5e5e5;
      }
      p {
        border: 1px solid $light-blue;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        color: $light-blue;
        font-size: 14px;
      }
    }
  }
  .node-ele.end {
    align-items: flex-start;
    .avatar-node {
      p {
        color: #fff;
        background-color: $light-blue;
      }
    }
  }
  .node-ele.start {
    align-items: flex-end;
  }
  .close-icon {
    position: absolute;
    bottom: -72px;
    left: 50%;
    width: 40px;
    height: 40px;
    line-height: 42px;
    text-align: center;
    border: 2px solid #fff;
    border-radius: 50%;
    transform: translateX(-50%);
    color: #fff;
    font-size: 24px;
  }
}
</style>
<style lang="scss">
.mobile-messagebox {
  width: 80vw;
  .el-message-box__btns {
    float: none !important;
  }
}
</style>
